/** @jsx jsx */
import { jsx, Flex, Box } from 'theme-ui';
import { useTranslation } from 'react-i18next';
import { useIsAndroid, useIsIOS } from '../hooks/useMobileOperatingSystem';
import { trackAppStoreLinkClick } from '../utils/analytics';

const googlePlayUrl =
  'https://play.google.com/store/apps/details?id=com.kyyti.ride.matkahuolto&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1';
const appStoreUrl = 'https://apps.apple.com/fi/app/reitit-ja-liput/id1496304929';

export default ({ type }) => {
  const { t: translate, i18n } = useTranslation();
  const language = i18n.language;
  const isAndroid = useIsAndroid();
  const isIOS = useIsIOS();
  return (
    <Box sx={{ bg: 'blueLighter', p: 3, pb: 2, borderRadius: 1 }}>
      <div>{translate(`account.${type}.seeInRL`)}</div>
      {!isIOS && !isAndroid && (
        <Flex sx={{ mt: 3, justifyContent: 'center' }}>
          <a href={googlePlayUrl} onClick={(event) => trackAppStoreLinkClick(event, googlePlayUrl)}>
            <img
              alt={translate('account.myCards.downloadGooglePlay')}
              src={`/play_button/${language}.png`}
              sx={{ maxHeight: '50px', mr: 2 }}
            />
          </a>
          <a href={appStoreUrl} onClick={(event) => trackAppStoreLinkClick(event, appStoreUrl)}>
            <img
              alt={translate('account.myCards.downloadAppStore')}
              src={`/app_store/${language}.svg`}
              sx={{ maxHeight: '50px', p: 1 }}
            />
          </a>
        </Flex>
      )}
      {isIOS && (
        <a
          sx={{ display: 'flex', alignItems: 'center', textDecoration: 'underline' }}
          href={appStoreUrl}
          onClick={(event) => trackAppStoreLinkClick(event, appStoreUrl)}
        >
          {translate('account.myCards.downloadRl')}
        </a>
      )}
      {isAndroid && (
        <a
          sx={{ display: 'flex', alignItems: 'center', textDecoration: 'underline' }}
          href={googlePlayUrl}
          onClick={(event) => trackAppStoreLinkClick(event, googlePlayUrl)}
        >
          {translate('account.myCards.downloadRl')}
        </a>
      )}
    </Box>
  );
};
